import { Box } from "@mui/material";
import { FONT_DISPLAY } from "../../theme/v2Tokens";
import { ReactNode } from "react";

interface KpiCardProps {
  title: string;
  accentColor: string;
  children: ReactNode;
  onClick?: (event: React.MouseEvent) => void;
  onAuxClick?: (event: React.MouseEvent) => void;
}

export default function KpiCard({
  title,
  accentColor,
  children,
  onClick,
  onAuxClick,
}: KpiCardProps) {
  const clickable = !!onClick;

  return (
    <Box
      onClick={onClick}
      onAuxClick={onAuxClick}
      sx={{
        flex: 1,
        minWidth: 160,
        bgcolor: "var(--bg-surface)",
        border: "1px solid var(--border-subtle)",
        borderRadius: "10px",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        ...(clickable && {
          cursor: "pointer",
          transition: "background-color 0.15s ease, border-color 0.15s ease",
          "&:hover": {
            bgcolor: "var(--bg-hover)",
            borderColor: "var(--border-mid)",
          },
        }),
      }}
    >
      <Box
        sx={{
          height: "3px",
          background: accentColor,
          flexShrink: 0,
        }}
      />

      <Box sx={{ padding: "14px 18px 16px", display: "flex", flexDirection: "column", gap: "6px" }}>
        <Box
          sx={{
            fontSize: "0.68rem",
            fontWeight: 600,
            letterSpacing: "0.05em",
            textTransform: "uppercase",
            color: "var(--text-muted)",
          }}
        >
          {title}
        </Box>

        <Box
          sx={{
            fontFamily: FONT_DISPLAY,
            fontSize: "1.6rem",
            fontWeight: 500,
            lineHeight: 1.1,
            color: accentColor,
            letterSpacing: "-0.02em",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
